import { Component, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JoinSessionVM } from '../../models/JoinSessionVM';
import { FormBuilder } from '@angular/forms';
import { CommsService } from '../../../services/comms.service';
import { JoinSessionResponseVM } from '../../models/JoinSessionResponseVM';
import { SessionType } from '../../models/SessionType';
import { SessionStatus } from '../../models/SessionStatus';

declare function setupVideo(): any;
declare function stopVideo(): any;

@Component({
  selector: 'step-1-video',
  templateUrl: './step-1-video.component.html'
})
export class Step1VideoComponent implements AfterViewInit {

  @Output() OnChanged: EventEmitter<number> = new EventEmitter();

  ngAfterViewInit(): void {
    setupVideo();
  }

  setDeviceSetupStage0() {
    this.OnChanged.emit(0);
  }

  setDeviceSetupStage2() {
    stopVideo();
    this.OnChanged.emit(2);
  }

}
